<template>
</template>

<script>
export default {
    name : 'TicketWidgetRightField',

    props : ['widget'],

    watch: {
      widget() {
        this.onWidgetChange();
      }
    },

    mounted() {
      this.onWidgetChange();
    },

    methods : {
      onWidgetChange() {
        var _this = this;

        if ( !this.widget || !this.widget.type ) {
          console.log('#26 onValueChange', this.widget, this);
          return;
        }

        // 右侧属性
        if ( 'RightMerchantOrder' == this.widget.type // 
          || 'RightMerchant' == this.widget.type // 
          || 'RightShop' == this.widget.type // 
          || 'RightEndAt' == this.widget.type // 
          || 'RightCustomerSchedule' == this.widget.type // 
          || 'RightWorkflow' == this.widget.type // 
          || 'RightCallInfo' == this.widget.type ) {

          $('.' + this.widget.type).show(); // 显示右侧组件
          this.hideRightMore();
          return;
        }
      },

      // 如果已全部显示,就隐藏右侧的其他按钮
      hideRightMore() {
        var len = $(`.RightMerchantOrder:hidden,
                    .RightMerchant:hidden,
                    .RightShop:hidden,
                    .RightEndAt:hidden,
                    .RightCustomerSchedule:hidden,
                    .RightWorkflow:hidden,
                    .RightCallInfo:hidden`).length;

        // 已全部显示
        if ( len < 1 ) {
          $('.right_1').slideUp(); // 隐藏按钮
        }
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketWidgetRightField.vue